var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import _ from "lodash";
import React from "react";
import "@frameworks/salesjourney/stylesheets/components/Generic/SearchField1.scss";
var SearchField1 = function (props) {
    var _a, _b, _c, _d;
    var _e = __read(React.useState(false), 2), isSearchFocused = _e[0], setIsSearchFocused = _e[1];
    var debounce = _.debounce(function (func) {
        func();
    }, 500);
    return (React.createElement("div", { className: (_a = props.parentClass) !== null && _a !== void 0 ? _a : "", onBlur: function () {
            setIsSearchFocused(false);
        } },
        isSearchFocused && (React.createElement("i", { className: "edel-icon-left-arrow hand_cursor", onClick: function () {
                props === null || props === void 0 ? void 0 : props.setSearchText("");
                // props?.setIsSearchFocused(false);
            } })),
        React.createElement("input", { className: "DMSanN_14_400 txt_blue-tint bg_white ", type: "search", defaultValue: (_b = props === null || props === void 0 ? void 0 : props.searchText) !== null && _b !== void 0 ? _b : "", value: (_c = props === null || props === void 0 ? void 0 : props.searchText) !== null && _c !== void 0 ? _c : "", placeholder: (_d = props === null || props === void 0 ? void 0 : props.placeholder) !== null && _d !== void 0 ? _d : "Search here ...", "aria-label": "Search", onChange: function (e) {
                // debounce(() => {
                props === null || props === void 0 ? void 0 : props.setSearchText(e.target.value);
                // });
            }, autoFocus: isSearchFocused, onFocus: function () { return setIsSearchFocused(true); } }),
        (props === null || props === void 0 ? void 0 : props.searchText) ? (React.createElement("span", { className: "edel-icon-close hand_cursor", onClick: function () {
                setIsSearchFocused(true);
                props === null || props === void 0 ? void 0 : props.setSearchText("");
            } })) : (React.createElement("i", { className: "edel-icon-search1" })))
    //   <div className={props.parentClassName ? props.parentClassName : ""}>
    //   <div
    //     className={`common-search-bar d-flex align-items-center ${
    //       props.searchBarBackground
    //     } ${openSearch && "open-search"}`}>
    //     {openSearch ? (
    //       <label
    //         htmlFor="focus-input"
    //         onMouseDown={() => {
    //           props?.onBack && props.onBack();
    //         }}>
    //         <span className="edel-icon-left-arrow "></span>
    //       </label>
    //     ) : (
    //       //  {/*  <label htmlFor="focus-input">
    //       //   <span
    //       //     className="edel-icon-left-arrow hand_cursor"
    //       //     onClick={() => {
    //       //       setSearchValue("");
    //       //       props.onCallbackFunction("");
    //       //       setOpenSearch(false);
    //       //       props?.onBack && props.onBack();
    //       //     }}
    //       //   ></span>
    //       // </label>  */}
    //       <label>
    //         <i
    //           className="edel-icon-search1"
    //           onClick={() => {
    //             setOpenSearch(true);
    //           }}></i>
    //       </label>
    //     )}
    //     <input
    //       disabled={props?.disabled}
    //       className={
    //         openSearch ? props.openInputBackground : props.searchBarBackground
    //       }
    //       id="focus-input"
    //       type="search"
    //       placeholder={
    //         device?.isDesktop ? props.deskPlaceHolder : props.mobPlaceHolder
    //       }
    //       value={searchValue}
    //       onChange={(e) => {
    //         setSearchValue(e.target.value);
    //         props.onCallbackFunction(e.target.value);
    //       }}
    //       onFocus={() => {
    //         setOpenSearch(true);
    //         props.onFocus && props?.onFocus();
    //       }}
    //       onBlur={() => {
    //         if (!searchValue) {
    //           setSearchValue("");
    //           //props.onCallbackFunction(""); init issue just click input field and click somewhere else getting reload
    //           setOpenSearch(false);
    //         }
    //         props.onBlur && props?.onBlur();
    //       }}
    //     />
    //     {openSearch && (
    //       <label htmlFor="focus-input">
    //         <i
    //           className="edel-icon-close txt_secondary-gray hand_cursor"
    //           onClick={() => {
    //             setSearchValue("");
    //             props.onCallbackFunction("");
    //             props.onClose && props.onClose();
    //           }}></i>
    //       </label>
    //     )}
    //   </div>
    // </div>
    );
};
export default SearchField1;
